import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch } from '../api/api';
import PublicHeader from '../layout/PublicHeader';
import PublicFooter from '../layout/PublicFooter';
import { toast } from 'react-toastify';
import '../App.css';

export default function CreateAccountPage() {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [agree, setAgree] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const row = {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  };

  const input = {
    padding: '7px 9px',
    border: '1px solid #ddd',
    borderRadius: 6,
    fontSize: 14,
    height: 34,
    boxSizing: 'border-box'
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');

    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    if (!agree) {
      setError('Please accept the Terms and Privacy Policy.');
      return;
    }

    setSubmitting(true);

    try {
      await apiFetch('/auth/register', {
        method: 'POST',
        body: {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          email: email.trim(),
          password
        }
      });

      toast.success(
        'Account created. Please check your email to verify your account.'
      );

      navigate('/check-your-email', {
        replace: true
      });
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        'Account creation failed.';

      setError(message);
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        background: '#fff',
        WebkitOverflowScrolling: 'touch'
      }}
    >
      <PublicHeader />

      <div
        style={{
          width: '100%',
          maxWidth: 520,
          margin: '0 auto',
          padding: '18px 20px 32px',
          boxSizing: 'border-box'
        }}
      >
        <style>{`
          .consumer-name-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
          }

          .consumer-account-form label {
            font-size: 13px;
            font-weight: 500;
          }

          .consumer-account-form button {
            min-height: 36px;
            font-size: 14px;
          }

          @media (max-width: 650px) {
            .consumer-name-grid {
              grid-template-columns: 1fr;
            }
          }
        `}</style>

        <h2
          style={{
            margin: '0 0 6px',
            fontSize: 22
          }}
        >
          Create your EveryID account
        </h2>

        <p
          style={{
            color: '#666',
            margin: '0 0 16px',
            fontSize: '13px',
            lineHeight: '1.4'
          }}
        >
          One account gives you secure access to EveryID-enabled
          applications.
        </p>

        {error && (
          <div
            style={{
              color: 'crimson',
              marginBottom: 12,
              fontSize: 13
            }}
          >
            {error}
          </div>
        )}

        <form
          className="consumer-account-form"
          onSubmit={handleSubmit}
        >
          <div className="consumer-name-grid">
            <div style={row}>
              <label>First name*</label>
              <input
                style={input}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                autoComplete="given-name"
                required
              />
            </div>

            <div style={row}>
              <label>Last name*</label>
              <input
                style={input}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                autoComplete="family-name"
                required
              />
            </div>
          </div>

          <div
            style={{
              ...row,
              marginTop: 10
            }}
          >
            <label>Email*</label>
            <input
              style={input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>

          <div
            className="consumer-name-grid"
            style={{
              marginTop: 10
            }}
          >
            <div style={row}>
              <label>Password*</label>
              <input
                style={input}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                minLength={6}
                required
              />
            </div>

            <div style={row}>
              <label>Confirm password*</label>
              <input
                style={input}
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                minLength={6}
                required
              />
            </div>
          </div>

          <label
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 7,
              marginTop: 12,
              fontSize: 12
            }}
          >
            <input
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
              style={{
                marginTop: 2,
                width: 14,
                height: 14
              }}
            />

            <span>
              I agree to the Terms of Service and Privacy Policy.
            </span>
          </label>

          <button
            type="submit"
            disabled={submitting}
            style={{
              width: '100%',
              marginTop: 14,
              padding: '8px 12px'
            }}
          >
            {submitting ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div
          style={{
            marginTop: 14,
            textAlign: 'center',
            fontSize: 13
          }}
        >
          Already have an EveryID account?{' '}
          <Link to="/login">
            Sign in
          </Link>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
}
